exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.mask[data-v-265e69df]{position:fixed;top:0;left:0;bottom:0;width:100%;z-index:9999;background:rgba(0,0,0,0.7);display:flex;align-items:center;justify-content:center;overflow:hidden\n}\n", "", {"version":3,"sources":["/root/workspace/copd-yiyao_k8gk/web/src/components/pic-mask.vue"],"names":[],"mappings":";AA8CA,uBACE,eACA,MACA,OACA,SACA,WACA,aACA,2BACA,aACA,mBACA,uBACA,eAAgB;CACjB","file":"pic-mask.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.mask {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  z-index: 9999;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-265e69df","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pic-mask.vue
// module id = Agps
// module chunks = 146